import * as types from '../constants/action-types';
import { Inventory } from '../../../../api/api-inventory';

export function resetInventoryStore () {
  return {
    type: types.RESET_INVENTORY_STORE
  };
}

export function inventoryFetchRequest (isFetching) {
  return {
    type: types.INVENTORY_FETCH_REQUEST,
    isFetching
  };
}

export function inventoryItemFetchRequest (isFetching) {
  return {
    type: types.INVENTORY_ITEM_FETCH_REQUEST,
    isFetching
  };
}

export function inventoryItemCreateRequest (isPosting) {
  return {
    type: types.INVENTORY_ITEM_CREATE_REQUEST,
    isPosting
  };
}

export function inventoryItemUpdateRequest (isPosting) {
  return {
    type: types.INVENTORY_ITEM_UPDATE_REQUEST,
    isPosting
  };
}

export function fetchInventory (spaceId, token, callback) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(inventoryFetchRequest(true));

      Inventory.read(spaceId, token, (response) => {
        dispatch(inventoryFetchRequest(false));

        if (response.error) {
          dispatch({ type: types.INVENTORY_FETCH_FAILURE });
          return reject(response.error);
        }

        if (callback) {
          callback(response);
        }

        dispatch({
          type: types.INVENTORY_FETCH_SUCCESS,
          data: response
        });
        return resolve(response);
      });
    });
  };
}

export function storeInventoryItem (item) {
  return dispatch => {
    return dispatch({
      type: types.INVENTORY_ITEM_STORE,
      item
    });
  };
}

export function fetchInventoryItem (itemId, callback) {
  return dispatch => {
    dispatch(inventoryItemFetchRequest(true));

    Inventory.readItem(itemId, (response) => {
      dispatch(inventoryItemFetchRequest(false));

      if (response.error) {
        return dispatch({ type: types.INVENTORY_ITEM_FETCH_FAILURE });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.INVENTORY_ITEM_FETCH_SUCCESS,
        item: response
      });
    });
  };
}

export function createInventory (payload, token, callback) {
  return dispatch => {
    dispatch(inventoryItemCreateRequest(true));

    Inventory.create(payload, token, (response) => {
      dispatch(inventoryItemCreateRequest(false));

      if (response.error) {
        return dispatch({ type: types.INVENTORY_ITEM_CREATE_FAILURE, error: response.error });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({
        type: types.INVENTORY_ITEM_CREATE_SUCCESS,
        data: response
      });
    });
  };
}

export function updateInventoryItem (payload, itemId, token, callback) {
  return dispatch => {
    dispatch(inventoryItemUpdateRequest(true));

    Inventory.updateItem(payload, itemId, token, (response) => {
      dispatch(inventoryItemUpdateRequest(false));

      if (response.error) {
        return dispatch({ type: types.INVENTORY_ITEM_UPDATE_FAILURE, error: response.error });
      }

      if (callback) {
        callback(response);
      }

      return dispatch({ type: types.INVENTORY_ITEM_UPDATE_SUCCESS });
    });
  };
}


export const deleteInventoryItem = (itemId, token) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch({ type: types.INVENTORY_ITEM_DELETE_REQUEST });

      Inventory.deleteItem(itemId, token, (response) => {
        if (200 === response.statusCode) {
          dispatch({ type: types.INVENTORY_ITEM_DELETE_SUCCESS });
          return resolve(response);
        }

        dispatch({ type: types.INVENTORY_ITEM_DELETE_FAILURE });
        return reject(response.error);
      });
    });
  };
};
